import Noty from 'noty';

Noty.setMaxVisible(5);

Noty.overrideDefaults({
	theme: 'vsenovostroyki',
	timeout: 1000
});

export default class Notifier extends Noty {
	static create (options) {
		return new Noty(options);
	}

	static prepareOptions (text = '', options = {}) {
		let opts;
		if (typeof text === 'object') {
			opts = text;
		} else if (typeof text === 'string' && typeof options === 'object') {
			opts = Object.assign(options, {text});
		} else {
			console.error('Incorrect types of arguments');
		}
		return opts;
	}

	static info (text, options) {
		this.create(Object.assign(this.prepareOptions(text, options), {type: 'info'})).show();
	}

	static alert (text, options) {
		this.create(Object.assign(this.prepareOptions(text, options), {type: 'alert'})).show();
	}

	static error (text, options) {
		this.create(Object.assign(this.prepareOptions(text, options), {type: 'error'})).show();
	}

	static success (text, options) {
		this.create(Object.assign(this.prepareOptions(text, options), {type: 'success'})).show();
	}

	static warning (text, options) {
		this.create(Object.assign(this.prepareOptions(text, options), {type: 'warning'})).show();
	}

	static echo () {
		// Notifier.alert('alert', {timeout: 5000});
		// Notifier.info('info', {timeout: 5000});
		// Notifier.success('success', {timeout: 5000});
		// Notifier.warning('warning', {timeout: 5000});
		// Notifier.error('error', {timeout: 5000});
		Notifier.alert('alert', {timeout: false});
		Notifier.info('info', {timeout: false});
		Notifier.success('success', {timeout: false});
		Notifier.warning('warning', {timeout: false});
		Notifier.error('error', {timeout: false});
	}
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_classes/Notifier.js